export const handleTrueFalseLabel = (
  label: string,
  t: (str: string) => string
) => {
  return ['true', 'false'].includes(label)
    ? label === 'true'
      ? t('true')
      : t('false')
    : label;
};
